import { render, staticRenderFns } from "./MediaDownloadImageItem.vue?vue&type=template&id=a2a158aa&scoped=true&"
import script from "./MediaDownloadImageItem.vue?vue&type=script&lang=ts&"
export * from "./MediaDownloadImageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaDownloadImageItem.vue?vue&type=style&index=0&id=a2a158aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a158aa",
  null
  
)

export default component.exports